import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CalendarModule } from 'primeng/calendar';
import { NgxCaptchaModule } from 'ngx-captcha';
import { OnlyNumberDirective } from '../only-number.directive';
import { PreventKeysDirective } from '../prevent-keys.directive';
import { CurrencyMaskDirective } from '../currency-mask.directive';
import { TwoDigitDecimalNumberDirective } from '../two-digit-decimal-number.directive';
import { PhoneMaskDirective } from '../phone-mask.directive';
import { InputMaskDirective } from '../input-mask.directive';
import { PercentageMaskDirective } from '../percentage-mask.directive';
import { InputMaxLengthDirective } from '../input-max-length-directive';
import { UrlDecode } from '../urldecode.pipe';
import { HtmlConverter } from '../html-converter.pipe';
import { Time24to12Format } from '../time24to12format.pipe';
import { CustomDatePipe } from '../custom.datepipe';
import { DateFormat } from '../dateFormat.datepipe';
import { CustomTimePipe } from '../custom.timepipe';
import { DayDateFormat } from '../dayDateFormat.datepipe';
import { WordLimit } from '../word-limit.pipe';
import { PriceFormat } from '../priceFormat.pipe';
import { LabelFormat } from '../labelFormat.pipe';
import { DateMonthFormat } from '../date-month-format.pipe';
import { SafeFormat } from '../safeFormat.pipe';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { HtmlSanitize } from '../html-sanitize.pipe';
import { StripHtmlTagsPipe } from 'src/app/stripHtmlTag.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { RouterModule } from '@angular/router';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from '../error.interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ImageCropperModule } from '../image-cropper/image-cropper.module';
import { AngularStickyThingsModule } from '@w11k/angular-sticky-things';
import { RatingModule } from 'primeng/rating';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { HighlightClickDirective } from '../highlight-click.directive';


@NgModule({
	declarations: [
		UrlDecode,
		CustomDatePipe,
		Time24to12Format,
		DateFormat,
		CustomTimePipe,
		DayDateFormat,
		OnlyNumberDirective,
		PreventKeysDirective,
		CurrencyMaskDirective,
		PhoneMaskDirective,
		TwoDigitDecimalNumberDirective,
		PercentageMaskDirective,
		InputMaskDirective,
		InputMaxLengthDirective,
		HtmlConverter,
		WordLimit,
		PriceFormat,
		LabelFormat,
		DateMonthFormat,
		SafeFormat,
		HtmlSanitize,
		StripHtmlTagsPipe,
		HighlightClickDirective

	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		DatePipe
	],
	imports: [
		AngularStickyThingsModule,
		ModalModule.forRoot(),
		FullCalendarModule,
		BsDatepickerModule.forRoot(),
		CalendarModule,
		GoogleMapsModule,
		NgbModule,
		ToastrModule.forRoot({
			positionClass: 'toast-top-full-width'
		}),
		CarouselModule,
		NgxCaptchaModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		ImageCropperModule,
		AutoCompleteModule,
		NgxSkeletonLoaderModule,
		NgxPaginationModule,
		RatingModule,
		PickerComponent
	],
	exports: [
		CommonModule,
		AngularStickyThingsModule,
		AutoCompleteModule,
		GoogleMapsModule,
		NgbModule,
		FullCalendarModule,
		ModalModule,
		BsDatepickerModule,
		ToastrModule,
		NgxSkeletonLoaderModule,
		NgxPaginationModule,
		CalendarModule,
		RatingModule,
		PickerComponent,
		NgxCaptchaModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		ImageCropperModule,
		UrlDecode,
		CustomDatePipe,
		DateFormat,
		CustomTimePipe,
		CarouselModule,
		OnlyNumberDirective,
		HighlightClickDirective,
		InputMaxLengthDirective,
		TwoDigitDecimalNumberDirective,
		CurrencyMaskDirective,
		InputMaskDirective,
		PercentageMaskDirective,
		PhoneMaskDirective,
		PreventKeysDirective,
		HtmlConverter,
		Time24to12Format,
		WordLimit,
		DayDateFormat,
		PriceFormat,
		LabelFormat,
		DateMonthFormat,
		SafeFormat,
		HtmlSanitize,
		StripHtmlTagsPipe
	]
})
export class SharedModule { }
